module.exports = __webpack_public_path__ + "img/PHONE.01ca4317.svg";